<template>
  <v-flex xs6 lg4 class="pb-4">
    <v-avatar size="38px" :class="avatarClass" @click="toggleFilter">
      <v-icon :color="color" dark>{{icon}}</v-icon>
    </v-avatar>
    <h5 class="body-1 primary--text d-inline pl-3">{{label}}</h5>
  </v-flex>
</template>

<script>
export default {
  props: {
    label: String,
    icon: String,
    disabled: Boolean,
    color: String
  },
  computed: {
    avatarClass() {
      if (this.disabled) {
        return "timeline--icon eventDisabled"
      } else {
        return "timeline--icon"
      }
    }
  },
  methods: {
    toggleFilter() {
      this.$emit("toggleFilter", { label: this.label })
    }
  }
}
</script>
